import React from "react";
import { styled, Stack, Typography } from "@mui/material";

const StyledChip = styled(Stack, {
  shouldForwardProp: prop =>
    prop !== "selectedColor" && prop !== "borderPlacement",
  name: "Chip"
})<{
  isSelected?: boolean;
  theme?: any;
}>(({ isSelected, theme }: any) => ({
  backgroundColor: isSelected
    ? theme.palette.common.primary
    : theme.palette.common.white,
  border: isSelected ? 0 : `1px solid ${theme.palette.common.borderGrey}`,
  fontWeight: 600,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  textTransform: "capitalize",
  color: theme.palette.common.black,
  borderRadius: "9px",
  cursor: "pointer"
}));

export interface ClickableBadgeVisualInterface {
  label: string;
  isSelected?: boolean;
  onClick: () => void;
}

const ClickableBadgeVisual: React.FC<ClickableBadgeVisualInterface> = ({
  label,
  isSelected,
  onClick
}: ClickableBadgeVisualInterface) => {
  return (
    <StyledChip
      isSelected={isSelected}
      alignItems="center"
      justifyContent="center"
      padding="7px 16px"
      maxWidth="115px"
      textAlign="center"
      onClick={onClick}
    >
      <Typography fontWeight={500} variant="h4">
        {label}
      </Typography>
    </StyledChip>
  );
};

export default ClickableBadgeVisual;
